import React, { useEffect } from 'react';

const SEO = ({ 
  title = 'Shyam Ranjan | Professional Full-Stack Web Developer & Software Engineer',
  description = 'Expert full-stack web developer specializing in React, Node.js, PHP, and modern web technologies. Founder of Ranjan Solution, delivering custom web applications and enterprise software solutions.',
  keywords = 'full-stack web developer, web development, React developer, Node.js developer, PHP developer, software engineer, web application development, custom websites, enterprise software, Ranjan Solution, Shyam Ranjan, frontend developer, backend developer, JavaScript developer, web designer, responsive web design, SEO optimization',
  image = '/og-image.jpg',
  url = 'https://shyam.ranjansolution.in'
}) => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Person",
    "name": "Shyam Ranjan",
    "url": url,
    "sameAs": [
      "https://www.linkedin.com/in/shyamranjan-sr",
      "https://github.com/shyamranjan-sr"
    ],
    "jobTitle": "Full-Stack Web Developer & Software Engineer",
    "worksFor": {
      "@type": "Organization",
      "name": "Ranjan Solution",
      "url": "https://ranjansolution.com"
    },
    "alumniOf": {
      "@type": "EducationalOrganization",
      "name": "PIET - Panipat Institute of Engineering and Technology"
    },
    "knowsAbout": [
      "Web Development",
      "Full-Stack Development",
      "React.js",
      "Node.js",
      "PHP",
      "JavaScript",
      "MySQL",
      "Software Engineering",
      "UI/UX Design",
      "Database Design",
      "API Development",
      "Cloud Deployment"
    ],
    "offers": {
      "@type": "Service",
      "serviceType": "Web Development Services",
      "description": "Custom web application development, enterprise software solutions, and full-stack development services",
      "areaServed": "Worldwide",
      "availableChannel": {
        "@type": "ServiceChannel",
        "serviceUrl": url,
        "servicePhone": "+91-7645871567"
      }
    },
    "hasCredential": {
      "@type": "EducationalOccupationalCredential",
      "credentialCategory": "Bachelor of Technology",
      "recognizedBy": {
        "@type": "Organization",
        "name": "Kurukshetra University"
      }
    }
  };

  const websiteStructuredData = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Shyam Ranjan Portfolio",
    "url": url,
    "description": "Professional portfolio showcasing full-stack web development projects and expertise",
    "author": {
      "@type": "Person",
      "name": "Shyam Ranjan"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Shyam Ranjan"
    },
    "potentialAction": {
      "@type": "SearchAction",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": url + "?q={search_term_string}"
      },
      "query-input": "required name=search_term_string"
    }
  };

  useEffect(() => {
    // Update page title
    document.title = title;
    
    // Update or create meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', description);
    
    // Update or create meta keywords
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (!metaKeywords) {
      metaKeywords = document.createElement('meta');
      metaKeywords.setAttribute('name', 'keywords');
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.setAttribute('content', keywords);
    
    // Update or create Open Graph meta tags
    const updateMetaTag = (property, content) => {
      let meta = document.querySelector(`meta[property="${property}"]`) || 
                  document.querySelector(`meta[name="${property}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('property', property);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content);
    };
    
    updateMetaTag('og:type', 'website');
    updateMetaTag('og:url', url);
    updateMetaTag('og:title', title);
    updateMetaTag('og:description', description);
    updateMetaTag('og:image', image);
    updateMetaTag('og:site_name', 'Shyam Ranjan Portfolio');
    
    // Twitter meta tags
    updateMetaTag('twitter:card', 'summary_large_image');
    updateMetaTag('twitter:url', url);
    updateMetaTag('twitter:title', title);
    updateMetaTag('twitter:description', description);
    updateMetaTag('twitter:image', image);
    
    // Update structured data
    let structuredDataScript = document.querySelector('script[type="application/ld+json"]');
    if (!structuredDataScript) {
      structuredDataScript = document.createElement('script');
      structuredDataScript.setAttribute('type', 'application/ld+json');
      document.head.appendChild(structuredDataScript);
    }
    structuredDataScript.textContent = JSON.stringify(structuredData);
    
    // Add website structured data
    let websiteStructuredDataScript = document.querySelectorAll('script[type="application/ld+json"]')[1];
    if (!websiteStructuredDataScript) {
      websiteStructuredDataScript = document.createElement('script');
      websiteStructuredDataScript.setAttribute('type', 'application/ld+json');
      document.head.appendChild(websiteStructuredDataScript);
    }
    websiteStructuredDataScript.textContent = JSON.stringify(websiteStructuredData);
    
  }, [title, description, keywords, image, url, structuredData, websiteStructuredData]);

  return null; // This component doesn't render anything visible
};

export default SEO;
